/**
 * `measurements.*` wire contract — garment measurement (POM) pins, Visual Style
 * File Phase 2b (§7.1). Lengths cross the wire as integer **millimetres**; the
 * SPA converts to/from the display unit. Behind `entitledProcedureFor("garment.qc")`.
 */
import { z } from "zod";
import { uuid } from "../_common.js";

export const pinView = z.enum(["front", "back"]);
const mm = z.number().int().min(0).max(1_000_000);
const pinCoord = z.number().min(0).max(100);

export const getForStyleInput = z.object({ styleId: uuid });

export const addInput = z.object({
  styleId: uuid,
  pomCode: z.string().trim().min(1).max(60),
  specMm: mm,
  tolMm: z.number().int().min(0).max(1_000_000),
  actualMm: mm,
  uom: z.string().trim().max(8).optional(),
  sampleRef: z.string().trim().max(40).nullable().optional(),
  pinX: pinCoord,
  pinY: pinCoord,
  pinView,
});
export const addOutput = z.object({ id: uuid });

export const measurementsView = z.object({
  styleId: uuid,
  measurements: z.array(
    z.object({
      id: uuid,
      pomCode: z.string(),
      specMm: z.number().int(),
      tolMm: z.number().int(),
      actualMm: z.number().int(),
      deviationMm: z.number().int(),
      inTolerance: z.boolean(),
      uom: z.string(),
      sampleRef: z.string().nullable(),
      pinX: z.number(),
      pinY: z.number(),
      pinView,
      measuredAt: z.string().datetime(),
    }),
  ),
});
export const getForStyleOutput = measurementsView;

export type MeasurementsViewWire = z.infer<typeof measurementsView>;
